import AWS     from 'aws-sdk';

var STRIP_STARTING_SLASHES = /^\/|\/$/g;

class S3 {
    constructor(data) {
        var _ = this;

        _.bucket = data.bucket;
        _.path = data.path;

        _.s3 = new AWS.S3({
            endpoint: new AWS.Endpoint(data.endpoint),
            accessKeyId: data.accessKeyId,
            secretAccessKey: data.secretAccessKey || prompt('What is your Secret Access Key'),
            region: data.region,
            apiVersion: 'latest',
            maxRetries: 1,
            signatureVersion: 'v4'
        });
    }

    get(key, done) {
        var _ = this;

        _.s3.getObject({
            Bucket: _.bucket,
            Key: (_.path || '').replace(STRIP_STARTING_SLASHES, '') + '/' + key.replace(STRIP_STARTING_SLASHES, ''),
        }, done);
    }

    set(key, data, done) {
        var _ = this;

        _.s3.putObject({
            Body: data,
            Bucket: _.bucket,
            Key: (_.path || '').replace(STRIP_STARTING_SLASHES, '') + '/' + key.replace(STRIP_STARTING_SLASHES, ''),
        }, done);
    }

    list(key, done) {
        var _ = this,
            prefix = (_.path || '').replace(STRIP_STARTING_SLASHES, '') + '/' + key.replace(STRIP_STARTING_SLASHES, '');


        if (prefix[prefix.length - 1] !== '/') {
            prefix += '/';
        }

        _.s3.listObjects({
            Bucket: _.bucket,
            Delimiter: '/',
            Prefix: prefix,
        }, function(err, data) {
            if (data) {
                var result = {};

                if (data.Contents) {
                    result.files = data.Contents.map(function(file) {
                        return {
                            name: file.Key.split('/').pop(),
                            key: file.Key
                        };
                    });
                }

                if (data.CommonPrefixes) {
                    result.folders = data.CommonPrefixes.map(function(folder) {
                        var folderPrefix = folder.Prefix.replace(/\/$/, '');

                        return {
                            name: folderPrefix.replace(prefix, ''),
                            key: folderPrefix
                        };
                    });
                }

                done(undefined, result);
            } else {
                done(err);
            }
        });
    }

    downloadURL(key, done) {
        var _ = this,
            url = _.s3.getSignedUrl('getObject', {
                Bucket: _.bucket,
                Key: key,
                Expires: 10
            });

        done(undefined, url);
    }
}


export default S3;
